import { render, staticRenderFns } from "./AdminModerationBannedUsers.vue?vue&type=template&id=5f30dc64&scoped=true&"
import script from "./AdminModerationBannedUsers.vue?vue&type=script&lang=js&"
export * from "./AdminModerationBannedUsers.vue?vue&type=script&lang=js&"
import style0 from "./AdminModerationBannedUsers.vue?vue&type=style&index=0&id=5f30dc64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f30dc64",
  null
  
)

export default component.exports